module.exports = __webpack_public_path__ + "6c2cdb0c06e00cdf4ddf483396b33244.svg";